import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

/**
 * Setup — Registration module navigation — spec-48 W1 (renamed from setup)
 */
export const setupRegistrationNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/setup-registration/dashboard', label: 'Dashboard' },
    ],
  },
  {
    title: 'Matters',
    items: [
      { path: '/setup-registration/matters', label: 'All Matters' },
      { path: '/setup-registration/kanban/all', label: 'Kanban Board' },
      { path: '/tasks', label: 'My Tasks' },  // spec-39 W4.5
    ],
  },
  {
    title: 'Operations',
    items: [
      { path: '/setup-registration/grid', label: 'Setup Grid' },
    ],
  },
];
